module.exports = __webpack_public_path__ + "static/media/icon_system_eye_1.1.886c5f2b.svg";